var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDatos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#adacad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_25",
    "data-name": "Capa 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_14",
    "data-name": "Rect\\xE1ngulo 14",
    className: "cls-1",
    x: 5.5,
    y: 14.5,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    className: "cls-1",
    x: 5.5,
    y: 10.5,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_16",
    "data-name": "Rect\\xE1ngulo 16",
    className: "cls-1",
    x: 5.5,
    y: 6.5,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2275",
    "data-name": "Trazado 2275",
    className: "cls-1",
    d: "M17.5,2.5H13.32a3,3,0,0,0-5.64,0H3.5a1.81,1.81,0,0,0-.4,0A2,2,0,0,0,1.66,3.73a1.87,1.87,0,0,0-.16.77v14a2.09,2.09,0,0,0,.16.78,2.12,2.12,0,0,0,.43.64,2,2,0,0,0,1,.55,2.69,2.69,0,0,0,.4,0h14a2,2,0,0,0,2-2V4.5A2,2,0,0,0,17.5,2.5Zm-7-.25A.75.75,0,1,1,9.75,3,.76.76,0,0,1,10.5,2.25Zm7,16.25H3.5V4.5h14Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDatos);
export default __webpack_public_path__ + "static/media/ic_datos.0690362c37e807b6ff9c40bf5ee28892.svg";
export { ForwardRef as ReactComponent };